import Link from "next/link";
import Image from "next/image";

const BlogListItems = ({ blogType, start, end, selectedBlogs, itemIdToAvoid }) => {
  // console.log(selectedBlogs)
  if (itemIdToAvoid) {
    selectedBlogs = selectedBlogs.filter((item) => item.content_id != itemIdToAvoid)
  }
  // console.log("after filter")
  // console.log(selectedBlogs)

  return (
    <>
      {selectedBlogs &&
        selectedBlogs.slice(start, end).map((item, index) => (
          <div
            className="rbt-card card-list variation-02 rbt-hover mt--30"
            key={index}
          >
            <div className="rbt-card-img">
              <Link href={`/${blogType}/${item.content_id}`}>
                <Image
                  src={item.image.thumbnail}
                  width={580}
                  height={300}
                  priority
                  alt="Card image"
                />{" "}
              </Link>
            </div>
            <div className="rbt-card-body">
              <h5 className="rbt-card-title">
                <Link href={`/${blogType}/${item.content_id}`}>{item.title}</Link>
              </h5>
              {/* <p>{item.date.published}</p> */}
              <div className="rbt-card-bottom">
                <Link className="transparent-button" href={`/${blogType}/${item.content_id}`}>
                  Read Article
                  <i>
                    <svg
                      width="17"
                      height="12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g stroke="#27374D" fill="none" fillRule="evenodd">
                        <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                        <path strokeLinecap="square" d="M.663 5.572h14.594" />
                      </g>
                    </svg>
                  </i>
                </Link>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default BlogListItems;
